import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import ProjectsShowcase from '../components/ProjectsShowcase';

const ProjectsPage: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      {/* Page Header */}
      <section className="proj-page-header">
        <div className="proj-page-inner">
          {/* Breadcrumb */}
          <nav className="proj-breadcrumb" aria-label="Fil d'Ariane">
            <Link to="/" className="proj-crumb">Accueil</Link>
            <span className="proj-crumb-sep">/</span>
            <span className="proj-crumb-current">Projets</span>
          </nav>

          <div className="sec-tag">Portfolio</div>
          <h1 className="proj-page-title">
            Parmi nos <em>Réalisations</em>
          </h1>
          <div className="gold-bar" />
          <p className="proj-page-intro">
            Une sélection de projets représentatifs — dashboards temps réel, intégrations CRM,
            automatisation de processus, IA générative, plateformes web, e-gouvernement, cloud et cybersécurité.
            Chaque projet livré en production, maintenu et monitoré.
          </p>
        </div>
      </section>

      {/* Full showcase */}
      <ProjectsShowcase />

      <style>{`
        .proj-page-header {
          background: var(--white);
          padding: 8rem 0 3rem;
          position: relative;
          overflow: hidden;
        }
        .proj-page-inner {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 2rem;
        }
        .proj-breadcrumb {
          display: flex;
          align-items: center;
          gap: .5rem;
          margin-bottom: 2rem;
          font-family: 'Montserrat', sans-serif;
          font-size: .62rem;
          font-weight: 500;
          letter-spacing: .16em;
          text-transform: uppercase;
        }
        .proj-crumb {
          color: var(--ink2);
          text-decoration: none;
          transition: color .2s;
        }
        .proj-crumb:hover { color: var(--blue); }
        .proj-crumb-sep {
          color: var(--ink2);
          opacity: .4;
        }
        .proj-crumb-current {
          color: var(--blue);
          font-weight: 600;
        }
        .proj-page-title {
          font-family: 'Cormorant Garamond', Georgia, serif;
          font-size: clamp(2.4rem, 5vw, 4rem);
          font-weight: 600;
          color: var(--ink);
          line-height: 1.1;
          margin: 0 0 1rem;
          letter-spacing: -.01em;
        }
        .proj-page-title em {
          font-style: italic;
          color: var(--blue);
        }
        .proj-page-intro {
          font-family: 'Montserrat', sans-serif;
          font-size: 1rem;
          font-weight: 300;
          color: var(--ink2);
          line-height: 1.8;
          max-width: 700px;
          margin: 1.5rem 0 0;
        }

        @media (max-width: 768px) {
          .proj-page-header { padding: 6rem 0 2rem; }
          .proj-page-inner { padding: 0 1rem; }
          .proj-page-intro { font-size: .85rem; }
          .proj-breadcrumb { margin-bottom: 1.5rem; }
        }
      `}</style>
    </>
  );
};

export default ProjectsPage;
